// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNewText_backdrop__vqwxY","z_index_100":"AddNewText_z_index_100__inlSX","modal_title":"AddNewText_modal_title__tZiAo","BlogIcon":"AddNewText_BlogIcon__ddalO"};